import cookies from "js-cookie";

const PAYEE_INTEGRATION_COOKIE_NAME = "payee_integration";
const A_YEAR_IN_MILLISECONDS = 31536000000;

export const setPayeeIntegrationCookie = (): void => {
  if (isPayeeIntegrationCookieSet()) {
    return;
  }
  const token = new URLSearchParams(window.location.search).get(
    PAYEE_INTEGRATION_COOKIE_NAME
  )!;
  cookies.set(PAYEE_INTEGRATION_COOKIE_NAME, token, {
    path: "/",
    expires: new Date(Date.now() + A_YEAR_IN_MILLISECONDS),
  });
  const url = new URL(window.location.href);
  url.searchParams.delete(PAYEE_INTEGRATION_COOKIE_NAME);
  window.history.replaceState({}, document.title, url.toString());
};

export const clearPayeeIntegrationCookie = (): void =>
  cookies.remove(PAYEE_INTEGRATION_COOKIE_NAME, { path: "/" });

export const getPayeeIntegrationCookie = (): string | undefined =>
  cookies.get(PAYEE_INTEGRATION_COOKIE_NAME);

export const isPayeeIntegrationCookieSet = (): boolean =>
  getPayeeIntegrationCookie() !== undefined;
